import React from 'react'
import { Link } from 'gatsby'
import tw, { styled } from 'twin.macro'

type MenuTreeLink = {
    title: string,
    url: string,
    options: {
        attributes: {
            target?: string,
            class?: string,
        }
    }
}

type MenuTreeItem = {
    link: MenuTreeLink,
    subtree: Array<MenuTreeItem>

}

type MenuProps = {
    tree: Array<MenuTreeItem>,
    otherSite: Array<MenuTreeItem>,
    otherSitePrefix: string,
    className?: string
}

const PopularLinksMenu: React.FC<MenuProps> = ({ tree, otherSite, otherSitePrefix = 'www', className }) => {

    const append = otherSite.find((item:MenuTreeItem) => item.link.url === '/');
    const replace = otherSitePrefix === 'www' ? 'residential' : otherSitePrefix;

    return (
        <Style className={[ className, "navigation__popular popular-links-menu"].join(' ')}>
            <ul className="navigation__popular-container">
            {tree.map(item => (
                <li key={item.link.url}>
                    {item.link.options?.attributes?.target ? (
                        <a
                            href={item.link.url}
                            className="popular-link"
                        >{item.link.title}</a>
                    ) : (
                        <Link
                            to={item.link.url.replace(`/${process.env.GATSBY_SITE}/`, '/')}
                        >{item.link.title}</Link>
                    )}
                    {item.subtree.length > 0 && (
                            <ul className="nav__dropdown">
                                {item.subtree.map((sub, x) => (
                                    <li key={x}>
                                        <Link
                                            className="nav__link"
                                            activeClassName="is-active"
                                            to={sub.link.url.replace(`/${process.env.GATSBY_SITE}/`, '/')}
                                        >{sub.link.title}</Link>
                                    </li>
                                ))}
                            </ul>
                        )}
                </li>
            ))}
            {append && (
                <li className="is-appended">
                    <a
                        href={`https://${otherSitePrefix}.novaenergy.co.nz${append.link.url}`}
                        className="popular-link"
                        >{append.link.title}</a>
                        {append.subtree.length > 0 && (
                            <ul className="nav__dropdown">
                                {append.subtree.map((sub, x) => (
                                    <li key={x}>
                                        <a
                                            className="nav__link"
                                            href={`https://${otherSitePrefix}.novaenergy.co.nz${sub.link.url.replace(`/${replace}/`, '/')}`}
                                        >{sub.link.title}</a>
                                    </li>
                                ))}
                            </ul>
                        )}
                </li>
            )}
            </ul>
        </Style>
    )
}
export default PopularLinksMenu;



const Style = styled.ul`

${tw `bg-silver w-full hidden md:table`}

    ul {
        ${tw `list-none`}
    }

    > .navigation__popular-container {
        ${tw `w-full mx-auto`}
        padding-left: 7vmin;
        padding-right: 7vmin;
        ${tw `hidden list-none text-base w-full lg:flex lg:py-10 xl:py-16`}

        > li {
            min-height: 100%;
            display: block;
            flex: 1;
            order: 2;

            &:first-child {
                order: -1;
            }

            &.is-appended {
                order: 1;
            }

            + li {
                margin-left: calc(1vmax + 1em);
            }

            ul {
                list-style: none;
                padding: 0;
                margin: 1.5em 0 0 0;
                font-size: 95%;

                > li + li {
                    margin-top: .75em;
                }

            }
        }
    }

    li {
        ${tw `mb-0`}
    }

    a {
        font-weight: 600;
        cursor: pointer;
        text-decoration: none;
        outline: none;
        ${tw `text-default outline-none no-underline font-semibold`}

        + ul a {
            font-weight: 500;
            ${tw `font-normal`}
        }

        &:focus-visible {
            color: var(--nova-orange);
        }

        &:active {
            ${tw `text-primary`}
        }

        @media (hover: hover) {
            &:hover {
                ${tw `text-primary`}
            }
        }

        &.is-active {
            ${tw `underline cursor-default text-default`}
            text-underline-offset: .1em;
        }

        span {
            ${tw `hidden`}
        }
    }
`